export enum ENV {
  develop = 'develop',
  stage = 'stage',
  prod = 'prod',
}
